import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/MessageCard/MessageCardAnatomy.mdx";
import Usage from "../../Docs/Components/MessageCard/MessageCardUsage.mdx";

import Examples from "../../Docs/Components/MessageCard/MessageCardExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Message card"
            description="Message card communicates brief messages about non-ephemeral states that affect the current page or section, with optional call to actions."
            apiSources={["azure-devops-ui/Components/MessageCard/MessageCard.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/MQwjeE1w88guLumiUSuiWspT/Notifications?node-id=0%3A1"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;